import ReportsMatchView from './views/ReportsMatchView.vue'
import ReportMatchViewData from './components/ReportMatchViewData.vue'

export default [
  {
    path: '/reportes-partido',
    name: 'reportes-partidos',
    component: ReportsMatchView,
    children: [
      {
        path: 'info',
        name: 'reporte-partido-info',
        component: ReportMatchViewData
      }
    ]
  }
]
